import { TILE_GAP } from './gridLayout'

export const MOBILE_MAX_VIEWPORT_WIDTH = 700

export const MOBILE_COLUMNS = 2

export const MOBILE_MIN_TILE_HEIGHT = 132

export type MobileGridLayout = {
  columns: number
  rows: number

  visible: number

  overflow: number

  isLastFullWidth: boolean
}

const EMPTY_LAYOUT: MobileGridLayout = {
  columns: MOBILE_COLUMNS,
  rows: 1,
  visible: 0,
  overflow: 0,
  isLastFullWidth: false
}

export const getMobileGridLayout = (
  count: number,
  height: number,
  gap: number = TILE_GAP,
  minTileHeight: number = MOBILE_MIN_TILE_HEIGHT
): MobileGridLayout => {
  if (count <= 0 || height <= 0) {
    return EMPTY_LAYOUT
  }

  if (count === 1) {
    return { columns: 1, rows: 1, visible: 1, overflow: 0, isLastFullWidth: false }
  }

  const rowsThatFit = Math.max(1, Math.floor((height + gap) / (minTileHeight + gap)))

  if (count === 2) {
    return rowsThatFit > 1
      ? { columns: 1, rows: 2, visible: 2, overflow: 0, isLastFullWidth: false }
      : { columns: 2, rows: 1, visible: 2, overflow: 0, isLastFullWidth: false }
  }

  const rows = Math.min(Math.ceil(count / MOBILE_COLUMNS), rowsThatFit)
  const capacity = rows * MOBILE_COLUMNS

  if (count <= capacity) {
    return {
      columns: MOBILE_COLUMNS,
      rows,
      visible: count,
      overflow: 0,
      isLastFullWidth: count % MOBILE_COLUMNS === 1
    }
  }

  return {
    columns: MOBILE_COLUMNS,
    rows,
    visible: capacity - 1,
    overflow: count - (capacity - 1),
    isLastFullWidth: false
  }
}
